module.exports = __webpack_public_path__ + "static/media/img_featuredissues-sexting_CH_V2.167e1e7d.png";